import { useNavigate } from 'react-router-dom'

import { Card } from '@/shared/components/ui/card'
import { buildLeadFilterUrl } from '@/shared/lib/leadNavigation'

export default function ConversionRateCard({ data, period, customRange }) {
  const navigate = useNavigate()
  const wonCount = data?.wonCount ?? data?.conversions ?? 0
  const total = data?.total ?? 0
  const pct = data?.percentage ?? 0

  const handleCardClick = () => {
    navigate(
      buildLeadFilterUrl('/sales/leads', {
        status: 'won',
        period,
        customRange,
      }),
    )
  }

  return (
    <Card
      onClick={handleCardClick}
      className="h-[260px] cursor-pointer transition hover:border-slate-300 hover:shadow-md overflow-hidden rounded-2xl border border-black/[0.06] bg-white shadow-[0_8px_24px_rgba(15,23,42,0.04)] sm:rounded-[20px]"
    >
      <div className="flex h-full flex-col p-4">
        <div className="flex items-center justify-between gap-2">
          <h3 className="text-sm font-semibold text-slate-900">
            Conversion Rate
          </h3>
          <span className="text-[10px] font-semibold text-fuchsia-600 hover:underline">
            View Won Leads &rarr;
          </span>
        </div>

        <div className="mt-2 flex items-end gap-2">
          <span className="text-[clamp(1.75rem,4vw,2.25rem)] font-extrabold leading-none tracking-tight text-slate-900">
            {pct}%
          </span>
          <span className="pb-1 text-xs text-slate-500">rate</span>
        </div>

        <p className="mt-1 text-[11px] text-slate-400">
          {wonCount} won of {total} total leads
        </p>

        <div className="mt-4 h-2 overflow-hidden rounded-full bg-slate-100">
          <div
            className="h-full rounded-full bg-gradient-to-r from-violet-500 to-fuchsia-500 transition-[width] duration-300"
            style={{
              width: `${Math.min(100, Math.max(0, pct))}%`,
            }}
          />
        </div>
      </div>
    </Card>
  )
}
